module.exports = __webpack_public_path__ + "img/versions.5dcaec16.png";